// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./IconTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Icon-module__Icon__pJmB3 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: visible;
}
/* 12px */
.Icon-module__SizeXXSmall__BVW1O {
    width: var(--ds-3x);
}
/* 16px */
.Icon-module__SizeXSmall__rvTp4 {
    width: var(--ds-4x);
}
/* 20px */
.Icon-module__SizeSmall__zoHGH {
    width: var(--ds-5x);
}
/* 24px */
.Icon-module__SizeMiddle__HROCb {
    width: var(--ds-6x);
}
/* 36px */
.Icon-module__SizeLarge__pxHs7 {
    width: var(--ds-9x);
}
/* 64px */
.Icon-module__SizeXL___G2E0 {
    width: var(--ds-3xl);
}

.Icon-module__Accent__MuG4M {
    color: var(--ds-icon-color-accent);
}

.Icon-module__Brand__BOvDb {
    color: var(--ds-icon-color-brand);
}

.Icon-module__BrandIndigo__tj8k1 {
    color: var(--ds-icon-color-brand-indigo);
}

.Icon-module__Default__ykXZ4 {
    color: var(--ds-icon-color-default);
}

.Icon-module__Inverted__uwwGl {
    color: var(--ds-icon-color-inverted);
}

.Icon-module__Informative__dGQIA {
    color: var(--ds-icon-color-informative);
}

.Icon-module__Negative__CG8El {
    color: var(--ds-icon-color-negative);
}

.Icon-module__Positive__SPdPa {
    color: var(--ds-icon-color-positive);
}

.Icon-module__Warning__pV7EW {
    color: var(--ds-icon-color-warning);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Icon": `Icon-module__Icon__pJmB3`,
	"SizeXXSmall": `Icon-module__SizeXXSmall__BVW1O`,
	"SizeXSmall": `Icon-module__SizeXSmall__rvTp4`,
	"SizeSmall": `Icon-module__SizeSmall__zoHGH`,
	"SizeMiddle": `Icon-module__SizeMiddle__HROCb`,
	"SizeLarge": `Icon-module__SizeLarge__pxHs7`,
	"SizeXL": `Icon-module__SizeXL___G2E0`,
	"Accent": `Icon-module__Accent__MuG4M`,
	"Brand": `Icon-module__Brand__BOvDb`,
	"BrandIndigo": `Icon-module__BrandIndigo__tj8k1`,
	"Default": `Icon-module__Default__ykXZ4`,
	"Inverted": `Icon-module__Inverted__uwwGl`,
	"Informative": `Icon-module__Informative__dGQIA`,
	"Negative": `Icon-module__Negative__CG8El`,
	"Positive": `Icon-module__Positive__SPdPa`,
	"Warning": `Icon-module__Warning__pV7EW`
};
export default ___CSS_LOADER_EXPORT___;
